export interface Preferences {
  id: string;
  email: boolean;
  bell: boolean;
  sms: boolean;
  push: boolean;
}

export type PreferencesDto = Partial<Omit<Preferences, 'id'>>;
